<script>
import LoadingBoxes from '@/V2/components/LoadingBoxes.vue';

export default {
  components: {
    LoadingBoxes,
  },
};
</script>

<template>
  <div class="customer-list-loading-bars d-flex flex-column">
    <div v-for="i in 3" class="loading-item d-flex align-items-center i-px-9">
      <loading-boxes :key="i" :config="{ repeat: 1, showAvatar: true }" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.customer-list-loading-bars {
  gap: 1px;

  .loading-item {
    background: $white-base;
    width: 100%;
    height: 72px;
  }
}
</style>
